export const formatToIndianDate = (dateInput) => {
    if (!dateInput) return '?';
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  export const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  export const formatDateForInput = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  }

  export const formatDateValue = (date) => {
    if (!date) return "";
  
    
    if (typeof date === "string" && date.includes("-")) {
      return formatDate(date);
    }
  
    if (date instanceof Date) {
      const isoString = date.toISOString().split("T")[0]; // "2025-09-18"
      return formatDate(isoString);
    }
  
    return "";
  };
  
  
  export const toInputDate = (date) => {
    if (!date) return "";
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`; // yyyy-mm-dd
  };
  
  export const fromInputDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`; // dd-mm-yyyy
  };